import { Component, Input } from '@angular/core';
import { NgxGpAutocompleteModule } from '@angular-magic/ngx-gp-autocomplete';

import { Store, createSelector } from '@ngrx/store';

import { DialogService } from 'primeng/dynamicdialog';

import { FreyaCommonModule } from '../../../freya-common/freya-common.module';
import { GoogleHelperService } from '../../../services/google-helper.service';
import { isLocationInvalid } from '../../../utilities/locations.util';


import { overviewLocationsFeature } from '../../job-overview/overview-locations/overview-locations.feature';
import { JobCreateLocationsActions } from '../job-create-locations/job-create-locations-state.actions';

@Component({
	selector: 'app-job-location',
	standalone: true,
	imports: [
    FreyaCommonModule,
    NgxGpAutocompleteModule
],
	templateUrl: './job-location.component.html',
	styleUrls: ['./job-location.component.scss']
})
export class JobLocationComponent {

	@Input() locationType: string;

	public viewModel$ = this.store.select(createSelector(
		overviewLocationsFeature.selectLocationEditors,
		(locationEditors) => ({
			location: locationEditors[ this.locationType ],
			locationInvalid: isLocationInvalid(locationEditors[ this.locationType ]),
		})
	))

	constructor(
			public store: Store,
			public googleHelper: GoogleHelperService,
			public dialogService: DialogService,
		) { }

	public actions = JobCreateLocationsActions;
}
